import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import templateServices from '../../services/TemplateServices'
import { autorun } from 'mobx';


@inject('LayoutTemplateStore', 'SportsStore', 'SportsMenuStore')
@observer
class LeftMenuComponent extends Component {
  constructor(props) {
		super(props)
    let dataComps = []
    let container = 'bodyContainer';
    let position = 'leftContainer';

    dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, "masterBodyLayout");
   
    this.state = {
      comps: templateServices.listComponentsByDataNoGrid(dataComps) || (<div></div>),
      isUseMasterLayout: true
     
    }  
  }

  componentDidMount() {
      this.autorun = autorun(() => {
          let isUseMasterLayout = this.props.LayoutTemplateStore.isUseMasterLayout;
          if (this.state.isUseMasterLayout !== isUseMasterLayout) {
              let container = 'bodyContainer';
              let position = 'leftContainer';
              //console.log("left autorun");
              let dataComps = []
              if (isUseMasterLayout) {
                dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position, "masterBodyLayout");
              } else {
                dataComps = templateServices.listDataCompsByContainerPosition(this.props.LayoutTemplateStore, container, position);

              }

            // console.log("dataComps", dataComps)
              this.setState({
                  comps: templateServices.listComponentsByDataNoGrid(dataComps) || ( <div> </div>),
                    isUseMasterLayout: isUseMasterLayout
                  }); 
               //console.log("this.state.comps", this.state.comps)
            }

          });
      }
  
  componentWillUnmount() {
    this.autorun();
  }
  render() {
    return (
       <div id ="left-menu-container" className={"left-menu-container "  + (this.props.className)?this.props.className:''}>
             {this.state.comps}
        </div>
    );
  }

}

export default LeftMenuComponent;


// WEBPACK FOOTER //
// ./src/app/components/LeftMenuComponent/index.js